// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fECt","type":"styles_type__1xd56","choices":"styles_choices__3Eazp"};